import {
    SET_ERROR_NOTIFICATION,
    SET_SUCCESS_NOTIFICATION,
    SET_WARNING_NOTIFICATION,
    SET_INFO_NOTIFICATION,
    DISMISS_ERROR_NOTIFICATION,
    DISMISS_SUCCESS_NOTIFICATION,
    DISMISS_WARNING_NOTIFICATION,
    DISMISS_INFO_NOTIFICATION,
    DISMISS_ALL_NOTIFICATIONS
} from '../../actions/actionTypes';

const INITIALSTATE = {
    error: {
        display: false,
        message: ''
    },
    success: {
        display: false,
        message: ''
    },
    warning: {
        display: false,
        message: ''
    },
    info: {
        display: false,
        message: ''
    }
};

export default function notifications(state = INITIALSTATE, action) {
    switch (action.type) {
        case SET_ERROR_NOTIFICATION:
            return {
                ...state,
                error: {
                    display: true,
                    message: action.payload
                }
            }
        case SET_SUCCESS_NOTIFICATION:
            return {
                ...state,
                success: {
                    display: true,
                    message: action.payload
                }
            }
        case SET_WARNING_NOTIFICATION:
            return {
                ...state,
                warning: {
                    display: true,
                    message: action.payload
                }
            }
        case SET_INFO_NOTIFICATION:
            return {
                ...state,
                info: {
                    display: true,
                    message: action.payload
                }
            }
        case DISMISS_ERROR_NOTIFICATION:
            return {
                ...state,
                error: {
                    display: false,
                    message: ''
                }
            }
        case DISMISS_SUCCESS_NOTIFICATION:
            return {
                ...state,
                success: {
                    display: false,
                    message: ''
                }
            }
        case DISMISS_WARNING_NOTIFICATION:
            return {
                ...state,
                warning: {
                    display: false,
                    message: ''
                }
            }
        case DISMISS_INFO_NOTIFICATION:
            return {
                ...state,
                info: {
                    display: false,
                    message: ''
                }
            }
        case DISMISS_ALL_NOTIFICATIONS:
            return INITIALSTATE;
        default:
            return state;
    }
}
